// src/services/redux/slices/authSlice.js
import { createSlice } from '@reduxjs/toolkit';

const loadAuth = () => {
  try {
    const raw = localStorage.getItem('auth');
    return raw ? JSON.parse(raw) : { token: null, user: null };
  } catch {
    return { token: null, user: null };
  }
};

const initialState = loadAuth();

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials(state, action) {
      const { token, user } = action.payload;
      state.token = token ?? state.token;
      state.user = user ?? state.user;
      try {
        localStorage.setItem('auth', JSON.stringify({ token: state.token, user: state.user }));
      } catch {

      }
    },
    clearCredentials(state) {
      state.token = null;
      state.user = null;
      try {
        localStorage.removeItem('auth');
      } catch {
        
      }
    },
  },
});

export const { setCredentials, clearCredentials } = authSlice.actions;
export default authSlice.reducer;
